import React, { useEffect, useState } from 'react';

// Bottom status bar: a slow tape of lines from Nico's own copy
// and a New York clock.
const LINES = [
  'TRADING IS A ZERO-SUM GAME',
  'INSIDE A LARGER POSITIVE-SUM GAME',
  'EVERY TRADE HAS A WINNER AND OFFSETTING LOSERS',
  'MARKETS AS A WHOLE DIRECT RESOURCES ACROSS SPACE AND TIME',
  'AND HELP CIVILIZATIONS GROW',
];

const clockFmt = new Intl.DateTimeFormat('en-US', {
  timeZone: 'America/New_York', hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit',
});

const tape = LINES.map((t, i) => (
  <React.Fragment key={i}>
    <b>▸</b> {t}
    {i < LINES.length - 1 ? '   ·   ' : '   '}
  </React.Fragment>
));

function Status() {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <footer className="status">
      <div className="status-ticker" aria-hidden="true">
        <div className="status-track">
          <span>{tape}</span>
          <span>{tape}</span>
        </div>
      </div>
      <div className="status-right">
        <span>NYC {clockFmt.format(now).replace(/^24/, '00')}</span>
      </div>
    </footer>
  );
}

export default Status;
